"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PATIENT_MODERATORS_FIELD_NAME = exports.MAX_MODERATORS_COUNT = exports.CLINICIAN_MODERATORS_FIELD_NAME = void 0;
var CLINICIAN_MODERATORS_FIELD_NAME = 'clinicianModerators';
exports.CLINICIAN_MODERATORS_FIELD_NAME = CLINICIAN_MODERATORS_FIELD_NAME;
var PATIENT_MODERATORS_FIELD_NAME = 'patientModerators';
exports.PATIENT_MODERATORS_FIELD_NAME = PATIENT_MODERATORS_FIELD_NAME;
var MAX_MODERATORS_COUNT = 9;
exports.MAX_MODERATORS_COUNT = MAX_MODERATORS_COUNT;